export default function homeReducer(state = {
  tiles_fetched: false,
  tiles_fetching: false,
  home_tiles: [],
  fetching: false,
  fetched: false,
  carousels_fetched: false,
  carousels_fetching: false,
  home_carousels: [],
  home_carousels_setting: '',
  carousel_speed: 5,
  user: {},
  errors: {}
}, action) {
  switch (action.type) {
    case 'GET_HOMEPAGE_CAROUSELS_SETTING_PENDING':
    case 'GET_CAROUSEL_PENDING':
    case 'GET_HOMEPAGE_TILES_PENDING':
    case 'GET_HOMEPAGE_TILE_PENDING': {
      return {
        ...state,
        fetching: true,
        fetch: false,
        tiles_fetched: false,
        tiles_fetching: true,
      }
    }
    case 'GET_HOMEPAGE_CAROUSELS_PENDING':
      return {
        ...state,
        fetching: true,
        fetch: false,
        carousels_fetched: false,
        carousels_fetching: true,
      }

    case 'GET_HOMEPAGE_CAROUSELS_SETTING_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        home_carousels_setting: action.payLoad.data,
      }
    }

    case 'GET_HOMEPAGE_CAROUSELS_FULFILLED': {

      return {
        ...state,
        fetching: false,
        fetched: true,
        home_carousels: action.payLoad.data,
        permissions: action.payLoad.data.length > 0 && action.payLoad.data[0].hasOwnProperty('attributes') ? action.payLoad.data[0].attributes.permissions : [],
        carousels_fetched: true,
        carousels_fetching: false,
      }
    }
    case 'GET_CAROUSEL_FULFILLED': {
      action.payLoad.permission_ids = {};
      action.payLoad.permissions.map((perm) => {
        perm.children.map(child => {
          if (child.checked) {
            const element = {};
            element['checked'] = true;
            action.payLoad.permission_ids[child.id] = element;
          }
        })
      });
      return {
        ...state,
        fetching: false,
        fetched: true,
        carousel: action.payLoad,
        saved: false,
      }
    }
    case 'GET_HOMEPAGE_TILES_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        home_tiles: action.payLoad.data,
        tiles_fetched: true,
        tiles_fetching: false,
      }
    }
    case 'GET_HOMEPAGE_TILE_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        home_tile: action.payLoad,

      }
    }
    case 'SET_CAROUSEL_SPEED':
      return {
        ...state,
        carousel_speed: action.payLoad
      }
    case 'SAVE_CAROUSEL_REJECTED':
    case 'GET_CAROUSEL_REJECTED':
    case 'GET_HOMEPAGE_CAROUSELS_SETTING_REJECTED':
    case 'GET_HOMEPAGE_CAROUSELS_REJECTED':
    case 'GET_HOMEPAGE_TILES_REJECTED':
    case 'GET_HOMEPAGE_TILE_REJECTED': {
      return {
        ...state,
        errors: action.payLoad
      }
    }
    default:
      return {...state};
  }
}



// WEBPACK FOOTER //
// ./src/reducers/homeReducer.js